import { render, staticRenderFns } from "./RematchDecideStep.vue?vue&type=template&id=71f76bd0"
import script from "./RematchDecideStep.vue?vue&type=script&lang=js"
export * from "./RematchDecideStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports